/* eslint-disable @typescript-eslint/no-explicit-any */
import { QuotationCoverage } from 'data-layer-cr/dist/models';
import { FatalRetryError } from 'data-layer-cr/dist/network/NetworkTypes';
import {
  ERROR_CODE,
  ERROR_DESCRIPTION,
  SELECTED_ENDORSMENT,
} from 'src/analytics';
import { getSelectedEndorsment } from 'src/functions/quotationMethods';

/**
 * We use this value to NOT call dashboard endpoints when we repopulate redux
 * since it is not necessary. This prevents a reload in payment page.
 */

export const RETRYPAYMENT = 'RETRY';

function insertString(string: string, index: number, value: string): string {
  return string.substring(0, index) + value + string.substring(index);
}

export function converToUUID(string: string): string {
  let uuid = string;
  uuid = insertString(uuid, 8, '-');
  uuid = insertString(uuid, 13, '-');
  uuid = insertString(uuid, 18, '-');
  uuid = insertString(uuid, 23, '-');

  return uuid;
}

export function isItAutoPx(isAutoPx: boolean): string {
  return isAutoPx ? 'Sí' : 'No';
}

export function getCorrectEventProperties(
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  error: any,
  events: { [key: string]: string },
  coverages: QuotationCoverage[],
): { [key: string]: string } {
  // This is easier for mixpanel when looking for Error Description, instead of an empty string
  const selectedEndorsement = getSelectedEndorsment(coverages);
  let correctEvents = events;
  if (selectedEndorsement !== '') {
    correctEvents = {
      ...events,
      [SELECTED_ENDORSMENT]: selectedEndorsement,
    };
  }

  if (error) {
    let message = '';
    let errorCode = 0;
    if (error instanceof FatalRetryError) {
      const { statusCode, description } = error.response;
      message = description;
      errorCode = statusCode;
    } else {
      const responseData = error.response?.data as {
        message?: string;
        statusCode?: number;
      };
      message = responseData?.message || '';
      errorCode = responseData?.statusCode || 0;
    }
    return {
      ...correctEvents,
      [ERROR_CODE]: errorCode.toString(),
      [ERROR_DESCRIPTION]: message,
    };
  }
  return correctEvents;
}
